import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 개인정보처리방침 (Privacy Policy)
 */
export default function PrivacyPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page" style={{ background: 'var(--bg)', paddingBottom: 'calc(40px + var(--safe-bottom))' }}>
      <header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
          background: 'var(--surface)',
          borderBottom: '1px solid var(--border)',
          padding: 'calc(var(--safe-top) + 14px) 20px 14px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          minHeight: 56,
        }}
      >
        <button className="back-btn" onClick={() => navigate(-1)} aria-label="뒤로 가기">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div className="page-header-title">개인정보처리방침</div>
        <div style={{ width: 36 }} />
      </header>

      <main style={{ padding: '24px 20px 40px', maxWidth: 480, margin: '0 auto' }}>
        <div style={{ marginBottom: 28 }}>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text)', letterSpacing: '-0.5px', marginBottom: 8 }}>
            개인정보처리방침
          </h1>
          <p style={{ fontSize: 13, color: 'var(--text-tertiary)', lineHeight: 1.6 }}>
            스마트오더(이하 "회사")는 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고
            이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보처리방침을
            수립·공개합니다.
          </p>
          <p style={{ fontSize: 12, color: 'var(--text-quaternary)', marginTop: 8 }}>
            시행일: 2026년 1월 1일
          </p>
        </div>

        <Section title="제1조. 수집하는 개인정보 항목">
          <p>회사는 원활한 서비스 제공을 위하여 아래와 같이 최소한의 개인정보를 수집합니다.</p>
          <SubTitle>가. 주문·결제 시 수집 항목</SubTitle>
          <ul className="privacy-list">
            <li>필수: 주문 내역, 테이블 번호, 결제 정보(카드사명, 승인번호 등)</li>
            <li>선택: 이메일 주소(전자영수증 발송 시), 휴대전화번호(주문 알림 수신 시)</li>
          </ul>
          <SubTitle>나. 고객 문의 시 수집 항목</SubTitle>
          <ul className="privacy-list">
            <li>필수: 이름, 이메일 주소, 문의 내용</li>
          </ul>
          <SubTitle>다. 자동 수집 항목</SubTitle>
          <ul className="privacy-list">
            <li>서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보, 기기 정보, 브라우저 종류 및 OS</li>
          </ul>
        </Section>

        <Section title="제2조. 개인정보 수집 및 이용 목적">
          <p>회사는 수집한 개인정보를 다음의 목적을 위해 이용합니다.</p>
          <ol className="privacy-ol">
            <li>주문 상품의 접수, 결제, 배송(서빙) 및 환불 처리</li>
            <li>전자 영수증 발급 및 주문 상태 안내</li>
            <li>고객 문의 대응 및 민원 처리</li>
            <li>서비스 부정 이용 방지 및 보안 유지</li>
            <li>서비스 품질 개선 및 통계 분석</li>
            <li>법령상 의무 이행 및 분쟁 해결</li>
          </ol>
        </Section>

        <Section title="제3조. 개인정보의 보유 및 이용 기간">
          <p>
            회사는 원칙적으로 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.
            다만, 관계 법령에 따라 아래와 같이 일정 기간 보관하는 경우가 있습니다.
          </p>
          <ul className="privacy-list">
            <li>계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)</li>
            <li>대금 결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)</li>
            <li>소비자의 불만 또는 분쟁 처리에 관한 기록: 3년 (전자상거래법)</li>
            <li>전자금융거래에 관한 기록: 5년 (전자금융거래법)</li>
            <li>접속 로그 기록: 3개월 (통신비밀보호법)</li>
          </ul>
        </Section>

        <Section title="제4조. 개인정보의 제3자 제공">
          <p>
            회사는 정보주체의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 서비스 제공을 위하여 아래와 같이
            불가피하게 제공하는 경우가 있으며, 이용자는 제공 사항을 확인하고 동의한 경우에 한해 제공됩니다.
          </p>
          <div className="privacy-table">
            <div className="privacy-table-row privacy-table-head">
              <div>제공받는 자</div><div>목적</div><div>항목</div>
            </div>
            <div className="privacy-table-row">
              <div>㈜포트원 (PortOne)</div>
              <div>결제 대행 및 승인</div>
              <div>주문번호, 결제금액, 결제수단 정보</div>
            </div>
            <div className="privacy-table-row">
              <div>각 PG사 (KG이니시스 등)</div>
              <div>카드 결제 승인</div>
              <div>카드 정보, 승인 결과</div>
            </div>
            <div className="privacy-table-row">
              <div>가맹 매장</div>
              <div>주문 접수 및 조리, 영수증 발행</div>
              <div>주문 내역, 테이블 번호</div>
            </div>
          </div>
        </Section>

        <Section title="제5조. 개인정보 처리 위탁">
          <p>회사는 원활한 서비스 운영을 위해 아래와 같이 개인정보 처리 업무를 위탁하고 있습니다.</p>
          <div className="privacy-table">
            <div className="privacy-table-row privacy-table-head">
              <div>수탁자</div><div>위탁 업무 내용</div>
            </div>
            <div className="privacy-table-row">
              <div>Cloudflare, Inc.</div>
              <div>콘텐츠 전송, 방화벽, 보안 및 DDoS 방어</div>
            </div>
            <div className="privacy-table-row">
              <div>Amazon Web Services</div>
              <div>서버 호스팅 및 데이터 저장</div>
            </div>
            <div className="privacy-table-row">
              <div>㈜포트원</div>
              <div>결제 대행 및 결제 수단 관리</div>
            </div>
          </div>
        </Section>

        <Section title="제6조. 정보주체의 권리·의무 및 행사 방법">
          <p>정보주체는 회사에 대해 언제든지 다음과 같은 권리를 행사할 수 있습니다.</p>
          <ol className="privacy-ol">
            <li>개인정보 열람 요구</li>
            <li>오류 등이 있을 경우 정정 요구</li>
            <li>삭제 요구</li>
            <li>처리 정지 요구</li>
          </ol>
          <p style={{ marginTop: 8 }}>
            위 권리 행사는 회사에 대해 서면, 전자우편 등을 통하여 할 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.
          </p>
        </Section>

        <Section title="제7조. 개인정보의 파기 절차 및 방법">
          <p>
            회사는 개인정보 보유 기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당
            개인정보를 파기합니다. 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제하며,
            종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
          </p>
        </Section>

        <Section title="제8조. 개인정보 보호책임자">
          <p>
            회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만 처리 및 피해
            구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
          </p>
          <div
            style={{
              background: 'var(--primary-light)',
              padding: 16,
              borderRadius: 12,
              marginTop: 10,
              fontSize: 13,
              lineHeight: 1.8,
              color: 'var(--text-secondary)',
            }}
          >
            <div><strong>개인정보 보호책임자</strong></div>
            <div>성명: (담당자명 등록 예정)</div>
            <div>직책: 개인정보보호팀장</div>
            <div>이메일: privacy@smartorder.example</div>
            <div>전화: 02-0000-0000</div>
          </div>
        </Section>

        <Section title="제9조. 개인정보처리방침의 변경">
          <p>
            본 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는
            경우에는 변경사항의 시행 7일 전부터 서비스 내 공지사항을 통하여 고지합니다.
          </p>
          <ul className="privacy-list" style={{ marginTop: 8 }}>
            <li>2026년 1월 1일: 최초 시행</li>
          </ul>
        </Section>
      </main>

      <style>{`
        .privacy-list {
          padding-left: 20px;
          margin: 8px 0;
        }
        .privacy-list li {
          font-size: 14px;
          color: var(--text-secondary);
          line-height: 1.75;
          margin-bottom: 4px;
        }
        .privacy-ol {
          padding-left: 22px;
          margin: 8px 0;
        }
        .privacy-ol li {
          font-size: 14px;
          color: var(--text-secondary);
          line-height: 1.75;
          margin-bottom: 4px;
        }
        .privacy-table {
          margin-top: 10px;
          border: 1px solid var(--border);
          border-radius: 12px;
          overflow: hidden;
        }
        .privacy-table-row {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 8px;
          padding: 10px 12px;
          font-size: 12px;
          color: var(--text-secondary);
          border-bottom: 1px solid var(--border);
          line-height: 1.5;
        }
        .privacy-table-row:last-child { border-bottom: none; }
        .privacy-table-head {
          background: var(--bg-secondary);
          font-weight: 700;
          color: var(--text);
          font-size: 12px;
        }
      `}</style>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 16, fontWeight: 700, color: 'var(--text)', marginBottom: 10, letterSpacing: '-0.3px' }}>
        {title}
      </h2>
      <div style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.75 }}>
        {children}
      </div>
    </section>
  );
}

function SubTitle({ children }) {
  return (
    <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)', marginTop: 12, marginBottom: 4 }}>
      {children}
    </div>
  );
}
